import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';


import { HomeComponent } from './home/home.component';
import { CertificatesComponent } from './certificates/certificates.component';
import { PortfolioComponent } from './portfolio/portfolio.component';

const routes: Routes = [ 

  { path: 'certificates', component: CertificatesComponent },
  { path: 'portfolio', component: PortfolioComponent   },
  { path: 'home',          component: HomeComponent },
  { path: '',   redirectTo: '/home', pathMatch: 'full' },
  { path: '**', component: HomeComponent},
  
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { anchorScrolling: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
